import { trackEvent } from "jose_modern/analytics";
import { Modal } from "jose_modern/modal";

const ANALYTICS_SOURCE = "free_nutrition_label_maker";

let initialized = false;

function createLanguageSettingsModal() {
  if (document.getElementById("language-settings-modal")) {
    return;
  }

  // Clone the hidden images to get proper HTML with all srcset attributes
  // (We do it this way to use the image helpers in ERB so we get proper CDN path etc)
  const labelSectionsImg = document.getElementById("label-sections-header-img");
  const languageSettingsImg = document.getElementById("language-settings-img");

  const labelSectionsHtml = labelSectionsImg ? labelSectionsImg.outerHTML : "";
  const languageSettingsHtml = languageSettingsImg ? languageSettingsImg.outerHTML : "";

  // Remove the original hidden container now that we've extracted the HTML
  const hiddenContainer = document.getElementById("language-modal-images");
  if (hiddenContainer) {
    hiddenContainer.remove();
  }

  // Note: I'm keeping this modal's HTML out of the static page since I don't want to add _too_ many
  // language-related keywords to the page, just in case that would skew the SEO keywords in some unintended way.
  // So, it lives here and is added dynamically if the link is clicked.
  const modalHTML = `
    <div id="language-settings-modal" class="modal">
      <div class="modal-background" data-closes></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title modal-title-responsive">Language Settings for Canadian Labels</p>
          <button class="delete" aria-label="close" data-closes></button>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <p>To change the language settings in the label editor:</p>
            <ol>
              <li>Select any Canadian label template</li>
              <li>
                <span class="label-sections-item">
                  <span class="label-sections-text-desktop">In the label editor sidebar, look for the&nbsp;</span>
                  <span class="label-sections-text-mobile">Open the "Label options" menu, then find </span>
                  <strong>Label sections:</strong> ${labelSectionsHtml}
                </span>
              </li>
              <li>Choose your preferred language option:
                <ul>
                  <li><strong>Bilingual</strong> (default) - Shows both English and French text, with English first</li>
                  <li><strong>French first</strong> - Shows both English and French text, with French first</li>
                  <li><strong>English only</strong> - Shows English text only</li>
                  <li><strong>French only</strong> - Shows French text only</li>
                </ul>
              </li>
            </ol>
            <div class="has-text-centered">
              ${languageSettingsHtml}
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
          <button class="button is-success" data-closes>Got it</button>
        </footer>
      </div>
    </div>
    `;

  document.body.insertAdjacentHTML("beforeend", modalHTML);
}

export function initFreeNutritionLabelMaker() {
  if (initialized) {
    return;
  }
  initialized = true;

  // Add source parameter to all sign-up links on page load
  const signUpLinks = document.querySelectorAll('a[href*="/sign_up"]');
  signUpLinks.forEach((link) => {
    const url = new URL(link.href);
    url.searchParams.set("source", ANALYTICS_SOURCE);
    link.href = url.toString();
  });

  document.addEventListener("click", (event) => {
    const target = event.target;

    const languageLink = target.closest(".js-language-settings-modal");
    if (languageLink) {
      event.preventDefault();
      createLanguageSettingsModal();
      Modal.show("#language-settings-modal");
      trackEvent("language_settings_modal_opened");
    }

    const templateLink = target.closest(".template-link");
    if (templateLink) {
      trackEvent("public_template_clicked", {
        recipe_name: templateLink.dataset.recipeName,
        recipe_id: templateLink.dataset.recipeId,
        seo_slug: templateLink.dataset.seoSlug,
      });
    }

    const signUpLink = target.closest('a[href*="/sign_up"]');
    if (signUpLink) {
      trackEvent("public_recipe_sign_up_clicked", {
        source: ANALYTICS_SOURCE,
      });
    }
  });
}
